import { render, staticRenderFns } from "./FeedToken.vue?vue&type=template&id=d9ca6aac&scoped=true&"
import script from "./FeedToken.vue?vue&type=script&lang=js&"
export * from "./FeedToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ca6aac",
  null
  
)

export default component.exports